import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "./api";

type AuthCtx = { user: any; loading: boolean; refresh: () => Promise<any>; setUser: (u: any) => void; logout: () => Promise<void> };
const Ctx = createContext<AuthCtx>(null as any);

export function hasAccess(u: any) {
  if (!u) return false;
  if (u.role === "owner") return true;
  if (["active", "trialing"].includes(u.subscription_status)) return true;
  if (u.current_period_end && new Date(u.current_period_end) > new Date()) return true;
  return false;
}

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const [user, setUser] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch {
      setUser(null);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // CRITICAL: skip /me when returning from OAuth; AuthCallback exchanges session_id first.
    if (window.location.hash?.includes("session_id=")) { setLoading(false); return; }
    refresh();
  }, [refresh]);

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("bestie_token");
    setUser(null);
  };

  return <Ctx.Provider value={{ user, loading, refresh, setUser, logout }}>{children}</Ctx.Provider>;
}

export const useAuth = () => useContext(Ctx);
